<section class="ao-block bg-gray-light">
  <header class="ao-header mt-3 mb-2">
    <div class="row">
      <div class="col-sm-10">
        <div sc-placeholder name="ab-credit-card" [rendering]="rendering"></div>
      </div>
    </div>
  </header>
  <div class="block ao-content mb-2 margin-top-negative">
    <div class="table-responsive">
      <table class="table table-striped">
        <colgroup class="row">
          <col class="col-sm-2" />
          <col class="col-sm-5" />
          <col class="col-sm-3" />
          <col class="col-sm-2" />
        </colgroup>
        <thead>
          <tr>
            <th
              [ngClass]="item.fields.css.value"
              *ngFor="let item of rendering.fields.items"
            >
              <span *scText="item.fields.label"></span>
              <i
                *ngIf="item.fields.hint.value"
                class="icon-info-circle tooltip-icon"
                matTooltipClass="info-tooltip"
                [matTooltip]="item.fields.hint.value"
              ></i>
            </th>
          </tr>
        </thead>
        <tbody *ngIf="!isLoading && transactions && transactions.length < 1">
          <tr>
            <td colspan="4" class="text-center">
              <span
                class="badge badge-warning"
                *scText="rendering.fields.noMoreLabel"
              ></span>
            </td>
          </tr>
        </tbody>
        <tbody *ngIf="transactions && transactions.length">
          <tr *ngFor="let transaction of transactions">
            <td>{{ transaction.date | abDate }}</td>
            <td>{{ transaction.merchant }}</td>
            <td>{{ transaction.country }}</td>
            <td
              class="text-right"
              [ngClass]="{
                'text-danger': transaction.amount.amount > 0,
                'text-success': transaction.amount.amount < 0
              }"
            >
              {{ transaction.amount | abCurrency }}
            </td>
          </tr>
        </tbody>
      </table>
      <div *ngIf="isLoading" class="loader-bar"></div>
      <div
        *ngIf="hasMore"
        infiniteScroll
        [infiniteScrollDistance]="2"
        [infiniteScrollThrottle]="500"
        [fromRoot]="true"
        (scrolled)="onScroll()"
      ></div>
    </div>
  </div>
</section>
